import { CommonService } from "src/app/service/common.service";
import { ItemLimitParamListDto } from "src/app/webservice/item-param-limit";

export class ItemLimitParamListRec {

  public itemCd: string;
  public itemName: string;
  public standard: string;
  public ctgCd0: string;
  public ctgName0: string;
  public ctgCd1: string;
  public ctgName1: string;
  public ctgCd2: string;
  public ctgName2: string;
  public ctgCd3: string;
  public ctgName3: string;
  public ctg0: string;
  public ctg1: string;
  public ctg2: string;
  public ctg3: string;
  public limitParamCnt: number;

  constructor(private commonService: CommonService) {
  }

  initByDto(itemSimpleDto: ItemLimitParamListDto) {
    for (var key of Object.keys(itemSimpleDto)) {
      this[key] = itemSimpleDto[key];
    }
    this.ctg0 = this.ctgCd0 + ":" + this.ctgName0;
    this.ctg1 = this.ctgCd1 + ":" + this.ctgName1;
    this.ctg2 = this.ctgCd2 + ":" + this.ctgName2;
    this.ctg3 = this.ctgCd3 + ":" + this.ctgName3;
  }
}